const PublicRouteV2 = ({children}) => {
  const keepChk = window.localStorage.getItem("keepChk");
  const userId = JSON.parse(keepChk === null ? window.sessionStorage.getItem("userId") : window.localStorage.getItem("userId"));
  const isAuthenticated = userId !== null;

  return isAuthenticated ? window.location.href = "/v2/shopInfo1" : children;
};

export default PublicRouteV2;
